import React, { useEffect, useState } from "react";
import api from "../services/api";
import PageHeader from "../components/common/PageHeader";
import { Icon } from '@iconify/react';
import { showToast } from '../helper/notifications'; // IMPORTED HELPER

const OverviewPage = () => {
  const [stats, setStats] = useState({ 
    totalTopLocations: 0, 
    totalMainLocations: 0, 
    totalSubLocations: 0, 
    totalUsers: 0 
  });
  const [loading, setLoading] = useState(false);

  const fetchStats = () => {
    api.get("/dashboard/stats")
      .then(res => setStats(res.data))
      .catch(err => {
        console.error(err);
        showToast("error", "Failed to refresh dashboard stats"); // UPDATED
      });
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const handleManualSync = () => {
    setLoading(true);
    // Simulating a sync action
    setTimeout(() => {
      fetchStats();
      setLoading(false);
      showToast("success", "Dashboard data synchronized"); // TEST SUCCESS TOAST
    }, 800);
  };

  const cardData = [
    { title: 'Total Top Locations', val: stats.totalTopLocations, icon: 'solar:map-point-bold', gradient: '1', circle: 'cyan' },
    { title: 'Total Main Locations', val: stats.totalMainLocations, icon: 'solar:buildings-bold', gradient: '2', circle: 'purple' },
    { title: 'Total Sub Locations', val: stats.totalSubLocations, icon: 'solar:shop-bold', gradient: '3', circle: 'info' },
    { title: 'Total Users', val: stats.totalUsers, icon: 'solar:user-bold', gradient: '4', circle: 'success-main' },
  ];

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-24">
        <PageHeader title="Dashboard" subtitle="Overview" />
        <button 
          onClick={handleManualSync} 
          disabled={loading}
          className="btn btn-primary-600 radius-8 px-20 py-11 d-flex align-items-center gap-2"
        >
          <Icon icon={loading ? "line-md:loading-twotone-loop" : "solar:restart-bold"} />
          Refresh Stats
        </button>
      </div>
      
      <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
        {cardData.map((card, i) => (
          <div className="col" key={i}>
            <div className={`card shadow-none border bg-gradient-start-${card.gradient} h-100`}>
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-primary-light mb-1">{card.title}</p>
                    <h6 className="mb-0">{card.val}</h6>
                  </div>
                  <div className={`w-50-px h-50-px bg-${card.circle} rounded-circle d-flex justify-content-center align-items-center shadow-xs`}>
                    <Icon icon={card.icon} className="text-white text-2xl mb-0" />
                  </div>
                </div>
                <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                  <span className="text-success-main fw-semibold d-inline-flex align-items-center gap-1">
                    <Icon icon="bxs:up-arrow" className="text-xs" /> +2
                  </span> 
                  Last 30 days
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default OverviewPage;